module.exports = __webpack_public_path__ + "img/linen-towels.dc0e818b.svg";